const CHECKOUT_LOADER_PATH_SUFFIX = "/bc-checkout-shop-app/bc-checkout-shop-app.js";
function normalizeOrigin(value) {
  return value.replace(/\/+$/, "");
}
function isShopifyPreviewHost(host) {
  return typeof host === "string" && host.toLowerCase().endsWith(".shopifypreview.com");
}
function isShopifyStorefrontHost(host) {
  return typeof host === "string" && host.toLowerCase().endsWith(".myshopify.com");
}
function isEmbeddedCheckoutScriptUrl(scriptSrc) {
  if (!scriptSrc) {
    return false;
  }
  try {
    const url = new URL(scriptSrc);
    return url.pathname.endsWith(CHECKOUT_LOADER_PATH_SUFFIX) && url.searchParams.has("id");
  } catch {
    return false;
  }
}
function findEmbeddedCheckoutScript(currentDocument) {
  if (!currentDocument) {
    return null;
  }
  const scripts = Array.from(currentDocument.getElementsByTagName("script"));
  return scripts.find((script) => isEmbeddedCheckoutScriptUrl(script.src)) ?? null;
}
function resolveBrandclubHostDomain(options = {}) {
  var _a;
  const currentDocument = options.currentDocument ?? (typeof document !== "undefined" ? document : void 0);
  const currentWindow = options.currentWindow ?? (typeof window !== "undefined" ? window : void 0);
  const embeddedCheckoutScript = findEmbeddedCheckoutScript(currentDocument);
  if (embeddedCheckoutScript == null ? void 0 : embeddedCheckoutScript.src) {
    return normalizeOrigin(new URL(embeddedCheckoutScript.src).origin);
  }
  if (!currentWindow || options.allowCurrentOriginFallback === false) {
    throw new Error("[web-app] Could not resolve host domain from the current runtime context.");
  }
  const currentHostname = (_a = currentWindow.location) == null ? void 0 : _a.hostname;
  if (!currentHostname || isShopifyStorefrontHost(currentHostname) || isShopifyPreviewHost(currentHostname)) {
    throw new Error(
      "[web-app] Could not resolve host domain for an embedded Shopify storefront. Ensure the checkout bundle is loaded correctly."
    );
  }
  return normalizeOrigin(currentWindow.location.origin);
}
function getAppIdFromHostDomain(hostDomain) {
  return normalizeOrigin(hostDomain).replace(/^https?:\/\//, "");
}
export {
  findEmbeddedCheckoutScript,
  getAppIdFromHostDomain,
  isEmbeddedCheckoutScriptUrl,
  isShopifyPreviewHost,
  isShopifyStorefrontHost,
  resolveBrandclubHostDomain
};
//# sourceMappingURL=domain.js.map
